module.exports = __webpack_public_path__ + "img/employee-3.62269718.jpg";